/**
 * App Component
 * =============
 * Main application component with routing configuration.
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';

// Public pages
import Home from './pages/public/Home';
import Features from './pages/public/Features';
import Integrations from './pages/public/Integrations';
import HowItWorks from './pages/public/HowItWorks';
import Results from './pages/public/Results';
import FAQ from './pages/public/FAQ';
import Contact from './pages/public/Contact';

// Auth pages
import Login from './pages/auth/Login';

// Protected pages
import Demo from './pages/protected/Demo';
import Dashboard from './pages/protected/Dashboard';

/**
 * App Component
 * Main application with routing and authentication.
 * 
 * @returns {JSX.Element} App component
 */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes with Layout */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="features" element={<Features />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="how-it-works" element={<HowItWorks />} />
            <Route path="results" element={<Results />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />
          </Route>
          
          {/* Protected routes (no Layout) */}
          <Route 
            path="/demo" 
            element={
              <ProtectedRoute>
                <Demo />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* 404 Fallback */}
          <Route 
            path="*" 
            element={
              <div className="min-h-screen flex items-center justify-center bg-dme-blue-800">
                <div className="text-center text-white">
                  <h1 className="text-6xl font-bold mb-4">404</h1>
                  <p className="text-xl mb-6">Page not found</p>
                  <a 
                    href="/"
                    className="px-6 py-3 bg-dme-orange text-white rounded-lg hover:bg-dme-orange-dark transition-colors"
                  >
                    Go Home
                  </a>
                </div>
              </div>
            } 
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
